import { Box, Button, Flex, Text, Image, useToast } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { adminHideCampaign, adminShowCampaign } from "../../api";

const toArray = (value) => {
  if (Array.isArray(value)) return value;
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
};

export default function InProgressCard({ item, onChanged }) {
  const navigate = useNavigate();
  const toast = useToast();
  const creatorAvatarUrls = toArray(item?.creatorAvatarUrls);
  const visibilityTag = item?.deletedAt
    ? { label: "숨김", bg: "#E53E3E" }
    : { label: "노출", bg: "#38A169" };

  const errorMessage = (e) =>
    e?.response?.data?.error?.message ||
    e?.response?.data?.message ||
    "캠페인 상태 변경 중 오류가 발생했습니다.";

  async function handleVisibilityChange() {
    try {
      if (item?.deletedAt) {
        await adminShowCampaign({ id: item.campaignId });
      } else {
        await adminHideCampaign({ id: item.campaignId });
      }
      toast({
        title: item?.deletedAt
          ? "캠페인을 노출했습니다."
          : "캠페인을 숨김 처리했습니다.",
        status: "success",
        duration: 1800,
        isClosable: true,
      });
      onChanged?.();
    } catch (e) {
      toast({
        title: "상태 변경 실패",
        description: errorMessage(e),
        status: "error",
        duration: 2500,
        isClosable: true,
      });
    }
  }

  return (
    <Flex
      position="relative"
      bg="white"
      p="12px"
      flexDir="column"
      borderRadius="12px"
      boxShadow="0px 2px 6px rgba(0,0,0,0.08)"
      border="1px solid #E2E8F0"
      _hover={{ boxShadow: "0px 4px 12px rgba(0,0,0,0.12)" }}
      transition="0.2s"
      gap="12px"
    >
      <Box
        position="absolute"
        top="-0.1px"
        left="0.1px"
        bg={visibilityTag.bg}
        color="white"
        px="10px"
        py="3px"
        fontSize="12px"
        borderRadius="8px"
        fontWeight="700"
        boxShadow="0 2px 6px rgba(0,0,0,0.12)"
      >
        {visibilityTag.label}
      </Box>
      <Text fontSize="20px" fontWeight="700" mt="16px">
        {item.proposalTitle}
      </Text>
      <Flex gap="8px">
        <Flex
          w="50%"
          border="1px solid #D1D4D9"
          borderRadius="8px"
          flexDir="column"
          p="8px"
        >
          <Text color="#5D6979" fontSize="12px" fontWeight="500">
            제안자
          </Text>
          <Text color="#172940" fontSize="16px" fontWeight="600">
            {item.proposalSentBy}
          </Text>
        </Flex>
        <Flex
          w="50%"
          border="1px solid #D1D4D9"
          borderRadius="8px"
          flexDir="column"
          p="8px"
        >
          <Text color="#5D6979" fontSize="12px" fontWeight="500">
            제안일
          </Text>
          <Text color="#172940" fontSize="16px" fontWeight="600">
            {item.proposalSentAt?.split("T")[0]}
          </Text>
        </Flex>
      </Flex>
      <Flex
        w="100%"
        border="1px solid #D1D4D9"
        borderRadius="8px"
        flexDir="column"
        p="8px"
      >
        <Text color="#5D6979" fontSize="12px" fontWeight="500">
          캠페인명
        </Text>
        <Text color="#172940" fontSize="16px" fontWeight="600">
          {item.campaignTitle}
        </Text>
      </Flex>
      <Flex
        w="100%"
        border="1px solid #D1D4D9"
        borderRadius="8px"
        flexDir="column"
        p="8px"
      >
        <Text color="#5D6979" fontSize="12px" fontWeight="500">
          예상 총 비용
        </Text>
        <Text color="#172940" fontSize="16px" fontWeight="600">
          {item.expectedTotalCost}
        </Text>
      </Flex>
      <Flex
        w="100%"
        border="1px solid #D1D4D9"
        borderRadius="8px"
        flexDir="column"
        p="8px"
        gap="6px"
      >
        <Text color="#5D6979" fontSize="12px" fontWeight="500">
          추천 크리에이터
        </Text>

        {/* 카드 width 기준 내부에 꽉 차도록 수정 */}
        <Flex gap="6px" overflow="hidden" maxW="100%" alignItems="center">
          {creatorAvatarUrls.map((p, idx) => (
            <Image
              key={idx}
              src={p}
              w="40px"
              h="40px"
              borderRadius="full"
              objectFit="cover"
              flexShrink={0}
            />
          ))}

          {creatorAvatarUrls.length > 4 && (
            <Flex
              w="40px"
              h="40px"
              borderRadius="full"
              bg="#10B8E8"
              color="white"
              fontWeight="700"
              fontSize="14px"
              alignItems="center"
              justifyContent="center"
              flexShrink={0}
            >
              +{creatorAvatarUrls.length - 4}
            </Flex>
          )}
        </Flex>
      </Flex>

      <Flex gap="8px">
        <Button
          bg="white"
          border="1px solid #718096"
          color="#2D3748"
          w="120px"
          h="50px"
          borderRadius="12px"
          onClick={handleVisibilityChange}
        >
          {item.deletedAt ? "노출하기" : "숨기기"}
        </Button>
        <Button
          bgColor="#0054C0"
          flex="1"
          color="white"
          h="50px"
          borderRadius="12px"
          onClick={() => navigate(`/suggest/offering/${item.campaignId}`)}
        >
          상세보기
        </Button>
      </Flex>
    </Flex>
  );
}
